import type { CheckoutSession, PaymentOption } from '@/lib/types';

interface Props {
  session: CheckoutSession;
  paymentOptions: PaymentOption[];
  onConfirm: () => void;
  onCancel: () => void;
}

export function WalletConfirm({ session, onConfirm, onCancel }: Props) {
  const amountFormatted = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: session.currency,
    minimumFractionDigits: 2,
  }).format(parseFloat(session.amount));

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
        {/* Wallet icon */}
        <div className="flex items-center justify-center w-16 h-16 bg-brand-50 rounded-2xl mx-auto mb-6">
          <svg className="w-8 h-8 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
        </div>

        <h2 className="text-xl font-bold text-gray-900 text-center mb-2">
          Pagar con billetera
        </h2>
        <p className="text-gray-500 text-center mb-6">
          Se debitará <span className="font-semibold text-gray-900">{amountFormatted}</span> de tu billetera Orangepill.
        </p>

        <div className="space-y-3">
          <button
            onClick={onConfirm}
            className="w-full bg-brand-600 text-white font-semibold py-3 px-6 rounded-xl hover:bg-brand-700 active:scale-95 transition-all"
          >
            Confirmar pago
          </button>
          <button
            onClick={onCancel}
            className="w-full text-gray-600 font-medium py-3 px-6 rounded-xl border border-gray-200 hover:bg-gray-50 transition-colors"
          >
            Usar otro método
          </button>
        </div>
      </div>
    </div>
  );
}
